import { SectionType } from 'components/Section/Section'
import { Colour } from 'components/variables'
import { actions } from 'react-redux-form'
import { AllowedFunnelOrderValues, FunnelOrder } from '.'
import { getCdnUrl } from '../../../data/api/cdn'
import { isActive } from '../../../pages/willyWonka/utils'
import { store } from '../../../store/store'
import { getEntry, isEntryActive } from '../../entries/entry'
import { Entry, EntryKey } from '../../entries/types'
import { AppState } from '../../state'
import { Theme } from './theme'
import { IncomingTime, OutgoingTime } from './times'

export function getThemeColour(theme: Theme, entryKey: EntryKey) {
  if (entryKey !== EntryKey.none) {
    const entry = getEntry(entryKey)
    return entry ? entry.colour : Colour.glory
  } else {
    if (isActive()) {
      return Colour.red
    }
    const colourMap = new Map([
      [Theme.multiFly, Colour.steelBlue],
      [Theme.multiDrive, Colour.steelBlue],
      [Theme.totm, Colour.steelBlue],
      [Theme.solo, Colour.mint],
    ])
    return colourMap.get(theme) || Colour.glory
  }
}

export function getThemeSectionProps(theme: Theme, entryKey: EntryKey) {
  const patternImage = getThemeBackground(theme, entryKey)
  const rightPatternImage = getRightThemeBackground(theme, entryKey)
  const type = patternImage ? SectionType.background : SectionType.solid
  return { type, patternImage, rightPatternImage }
}

function getThemeBackground(theme: Theme, entryKey: EntryKey) {
  if (entryKey === EntryKey.none && isActive()) {
    return getCdnUrl('AYNIM-bg.jpg')
  }
  return undefined
}

function getRightThemeBackground(theme: Theme, entryKey: EntryKey) {
  if (entryKey === EntryKey.none && isActive()) {
    return getCdnUrl('AYNIM-logos-side.png')
  }
  return undefined
}

export function updateFunnelOrder(order: Partial<FunnelOrder>) {
  const state: AppState = store.getState()

  const excludeKeys = ['theme', 'entry', 'paymentAmount', 'total']
  const keys = Object.keys(order)
  excludeKeys.forEach(key =>
    keys.splice(keys.indexOf(key), keys.indexOf(key) === -1 ? 0 : 1),
  )

  for (const key of keys) {
    const oldOrder = state.funnelOrder as any
    const newOrder = order as any
    if (newOrder[key] !== oldOrder[key]) {
      store.dispatch(actions.change('funnelOrder.' + key, newOrder[key]))
    }
  }
}

export function generateAllowedOrderParams(
  theme: Theme,
  entry?: Entry,
): Partial<AllowedFunnelOrderValues> {
  let allowedParams: Partial<AllowedFunnelOrderValues> = {}

  if (entry && isEntryActive(entry) && entry.page && entry.page.allowedParams) {
    allowedParams = entry.page.allowedParams
  } else if (theme === Theme.fly) {
    allowedParams = {
      incomingTime: [
        IncomingTime.WholeDay,
        IncomingTime.Morning,
        IncomingTime.Afternoon,
      ],
      outgoingTime: [
        OutgoingTime.WholeDay,
        OutgoingTime.Morning,
        OutgoingTime.Afternoon,
      ],
    }
  } else if (theme === Theme.multiFly) {
    allowedParams = {
      incomingTime: [IncomingTime.Morning, IncomingTime.Afternoon],
      outgoingTime: [OutgoingTime.Morning, OutgoingTime.Afternoon],
    }
  }

  return allowedParams
}

export function autoFixFunnelOrder(
  allowedParams: Partial<AllowedFunnelOrderValues>,
): string[] {
  const updatedKeys = []
  const state: AppState = store.getState()

  const allowedParamKeys = Object.keys(allowedParams)

  for (const paramKey of allowedParamKeys) {
    if (!state.funnelOrder.hasOwnProperty(paramKey)) {
      continue
    }
    const oldOrder = state.funnelOrder as any
    const newOrder = allowedParams as any

    if (!newOrder[paramKey].includes(oldOrder[paramKey])) {
      store.dispatch(
        actions.change('funnelOrder.' + paramKey, newOrder[paramKey][0]),
      )
      updatedKeys.push(paramKey)
    }
  }

  return updatedKeys
}
